<script setup lang="ts">
import type { ChipProps } from './UICarouselChips.props'

defineProps<ChipProps>()

const emit = defineEmits(['select'])
</script>

<template>
  <button
    v-bind="$attrs"
    class="flex flex-col items-center gap-2.5"
    @click="emit('select')"
  >
    <div
      class="aspect-4/5 h-[105px] w-[84px]"
      :class="{ 'border-stroke-primary border': chipSelected }"
    >
      <NuxtPicture
        v-if="chip.categoryImage"
        :src="chip.categoryImage.url"
        provider="cloudinary"
        :alt="chip.categoryImage.alt"
        class="h-full w-full"
        sizes="84px"
        :modifiers="{ aspectRatio: '4:5' }"
        fit="fill"
      />
    </div>
    <p
      class="text-light-7 text-text-primary max-w-full hyphens-auto break-words text-center"
    >
      <span>
        {{ chip.label }}
      </span>
      <span> ({{ count }}) </span>
    </p>
  </button>
</template>
